import DataStoreFields from 'js/data-store/data-store-fields/data-store-fields';

const namespace = `fieldCache`;

const propertiesByField = {
	fieldType:{
		computer(fieldGUID){
			 return this.sheetGlobalState.dataStore.meta.schema.fields[fieldGUID].field.fieldType;
		}
	},
	picklistSupported:{
		computer(fieldGUID){
			const fieldType = this[`${namespace}_${'fieldType'}`][fieldGUID];
			return DataStoreFields.fieldTypes[fieldType].features.picklist.supported;	
		},
	},
	picklistValues:{
		computer(fieldGUID){
			if(this.activeSheetView){
				const picklistSupported = this[`${namespace}_${'picklistSupported'}`][fieldGUID];
				if(picklistSupported){
					try{
						return this.sheetGlobalState.picklistController.getPicklistOptionsForField({
							fieldGUID,
							dataStore: this.sheetGlobalState.dataStore,
							sheetView: this.activeSheetView,
							systemState: this.$root.systemState,
							ConnectedApps: this.sheetGlobalState.ConnectedApps,
						});
					}
					catch(e){
						Assert.handleError(e, {
							message: `Unexpected error generating picklist values for field [${fieldGUID}]`,
							level: 90001,
						});
						return [];
					}			
				}				
			}
			return [];
		},
	},
	fieldCanChangeValue:{
		computer(fieldGUID){
			const fieldType = this[`${namespace}_${'fieldType'}`][fieldGUID];

			let checker = DataStoreFields.fieldTypes[fieldType].features.picklist.canChangeValue;

			if(typeof(checker) === 'function'){
				return checker({
					fieldGUID,
					dataStore: this.sheetGlobalState.dataStore,					
					systemState: this.$root.systemState,
					ConnectedApps: this.sheetGlobalState.ConnectedApps,
				});	
			}
			else{
				return checker;
			}
		},
	},
	activeLabels:{
		computer(fieldGUID){
			if(this.activeSheetView){
				const sheetViewGroup = this.activeSheetView.sheetViewGroup;
				if(sheetViewGroup.properties.labels.activeLabels[fieldGUID]){
					if(sheetViewGroup.properties.labels.activeLabels[fieldGUID].formatting){
						return sheetViewGroup.properties.labels.activeLabels[fieldGUID].formatting;
					}
				}
			}			
			return null;
		},
	}
}


class DataStoreFieldDetailsCacheMixin{
	constructor(){
		const dsfdcmSelf = this;

		dsfdcmSelf.data = function(){
			const initialValue = {};
			for(let property in propertiesByField){
				initialValue[property] = {};
			}
			return {
				[namespace]: initialValue
			};
		}

		dsfdcmSelf.computed = {};
		for(let property in propertiesByField){
			dsfdcmSelf.computed[`${namespace}_${property}`] = function(){
				// console.log(`Recalc ${property}`)
				const vcSelf = this;
				const retVal = {};				
				if(vcSelf.sheetGlobalState.dataStore){					
					for(let fieldGUID in vcSelf.sheetGlobalState.dataStore.meta.schema.fields){
						retVal[fieldGUID] = propertiesByField[property].computer.apply(vcSelf, [fieldGUID]);
					}
				}
				return retVal;
			}
		}

		dsfdcmSelf.watch = {};
		for(let property in propertiesByField){
			dsfdcmSelf.watch[`${namespace}_${property}`] = {
				immediate: true,
				handler(newVal){
					// console.log(`Updating ${property} to: `, newVal);
					this[namespace][property] = newVal;
				}
			}
		}

		dsfdcmSelf.provide = function(){
			return {
				[namespace]:this[namespace],
			};
		};


	}
}

export default DataStoreFieldDetailsCacheMixin;